module.exports = __webpack_public_path__ + "static/forms-bad-3357b3c72315b0d98cc1c7d3ded18944.png";